import CryptoJS from 'crypto-js';
import {EncryptedPayload} from "@core/models/Http/Response/EncryptedPayload";

export function decryptLoginPayload(
  payload: string,
  keyBase64 : string
) {
  const key = CryptoJS.enc.Base64.parse(keyBase64);
  const [ivBase64, cipherText] = payload.split(':');
  const iv = CryptoJS.enc.Base64.parse(ivBase64);

  const decrypted = CryptoJS.AES.decrypt(
    cipherText,
    key,
    { iv }
  ).toString(CryptoJS.enc.Utf8);

  return JSON.parse(decrypted);
}

export function decryptPayload(
  payload: EncryptedPayload,
  keyBase64 : string
){
  const key = CryptoJS.enc.Base64.parse(keyBase64);
  const ivBase64 = payload.iv;
  const iv = CryptoJS.enc.Base64.parse(ivBase64);
  const cipherText = payload.cipherText;

  return CryptoJS.AES.decrypt(
    cipherText,
    key,
    {iv}
  ).toString(CryptoJS.enc.Utf8);
}

export function decryptData(
  payload: string,
  keyBase64 : string
) {

  const key = CryptoJS.enc.Base64.parse(keyBase64);
  const [ivBase64, cipherText] = payload.split(':');
  const iv = CryptoJS.enc.Base64.parse(ivBase64);
  return CryptoJS.AES.decrypt(
    cipherText,
    key,
    {iv}
  ).toString(CryptoJS.enc.Utf8);
}
